"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fp = require("lodash/fp");

var _react = require("react");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    if (i % 2) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i]));
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Generated by CoffeeScript 2.3.2


var addHandlers;

addHandlers = function addHandlers(handlers, dependencyNames) {
  return function (props) {
    var createHandlerProps, dependencyName, handlerProps;

    createHandlerProps = function createHandlerProps() {
      return (0, _fp.mapValues)(function (createHandler) {
        return function () {
          var handler;
          handler = createHandler(props);
          return handler.apply(void 0, arguments);
        };
      })(handlers);
    };

    handlerProps = dependencyNames ? (0, _react.useMemo)(createHandlerProps, function () {
      var i, len, results;
      results = [];

      for (i = 0, len = dependencyNames.length; i < len; i++) {
        dependencyName = dependencyNames[i];
        results.push(props[dependencyName]);
      }

      return results;
    }()) : createHandlerProps();
    return _objectSpread({}, props, {}, handlerProps);
  };
};

var _default = addHandlers;
exports["default"] = _default;